module.exports = __webpack_public_path__ + "img/saldo_cod.b9d881c2.svg";